<div class="main-container">
    <div
        class="bottom-container ym-bg-white ym-shadow-layer-lg ym-px-4 ym-py-1 ym-display-flex ym-gap-2 ym-h-10 ym-align-items-center ym-overflow-hidden">
        <ng-container
            *ngTemplateOutlet="item;context:{route: homeRoute, icon: isActiveRoute(routeNames.HOME)?iconNames.HOME_FILLED:iconNames.HOME, label:'Home', active: isActiveRoute(routeNames.HOME)}"></ng-container>
        <!-- <ng-container
            *ngTemplateOutlet="createItem;context:{route:null, icon: iconNames.PLUS_CIRCLE, label:'Create'}"></ng-container> -->
        <ng-container
            *ngTemplateOutlet="item;context:{route: searchRoute, icon: isActiveRoute(routeNames.SEARCH)?iconNames.SEARCH_FILLED:iconNames.SEARCH, label:'Search', active: isActiveRoute(routeNames.SEARCH)}"></ng-container>
        <!-- <ng-container
            *ngTemplateOutlet="item;context:{route: reportsRoute, icon: isActiveRoute(routeNames.REPORTS)?iconNames.CHART_FILLED:iconNames.CHART, label:'Reports', active: isActiveRoute(routeNames.REPORTS)}"></ng-container> -->
        <ng-container
            *ngTemplateOutlet="item;context:{route: contactsRoute, icon: isActiveRoute(routeNames.CONTACTS)?iconNames.USERS_FILLED:iconNames.USERS, label:'Contacts', active: isActiveRoute(routeNames.CONTACTS)}"></ng-container>
        <ng-container
            *ngTemplateOutlet="item;context:{route: tasksRoute, icon: isActiveRoute(routeNames.TASKS)?iconNames.CLIPBOARD_CHECK_FILLED:iconNames.CLIPBOARD_CHECK, label:'Tasks', active: isActiveRoute(routeNames.TASKS)}"></ng-container>
    </div>
</div>

<ng-template #item let-route="route" let-icon="icon" let-label="label" let-active="active">
    <a [routerLink]="route" [class.active-item]="active"
        class="item ym-text-decoration-none ym-py-2 ym-text-color ym-active-shadow-button-inset ym-w-full ym-display-flex ym-flex-direction-column ym-gap-1 ym-transition-duration-medium ym-hover-bg-t-gray-a-04 ym-rounded-lg">
        <span class="icon ym-svg-lg">
            <ym-icon [iconName]="icon"></ym-icon>
        </span>
        <span
            class="text ym-text-secondary ym-font-sm ym-text-center ym-line-height-normal ym-user-select-none">{{label}}</span>
    </a>
</ng-template>

<ng-template #createItem let-route="route" let-icon="icon" let-label="label" let-active="active">


    <ym-dropdown [showDropdown]="isDropdownOpen" (onDropdownClose)="toggleDropdown(false)"
        [position]="popoverPositions.ABOVE" [dropdownOption]="dropdownOptions" (selectedOption)="selectedOption($event)"
        class="ym-w-full">
        <ng-container trigger>
            <button [class.active-item]="active" (click)="toggleDropdown(true)"
                class="item ym-bg-transparent ym-border-none ym-text-decoration-none ym-py-2 ym-text-color ym-active-shadow-button-inset ym-w-full ym-display-flex ym-flex-direction-column ym-gap-1 ym-transition-duration-medium ym-hover-bg-t-gray-a-04 ym-rounded-lg">
                <span class="icon ym-svg-lg ym-mx-auto">
                    <ym-icon [iconName]="icon"></ym-icon>
                </span>
                <span
                    class="text ym-text-secondary ym-font-sm ym-w-full ym-text-center ym-line-height-normal ym-user-select-none">{{label}}</span>
            </button>
        </ng-container>
    </ym-dropdown>
</ng-template>